import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputCombo from "../../helpers/InputCombo";
import InputSearchEmp from "../../helpers/InputSearchEmp";
import InputDateMulti from "../../helpers/InputDateMulti";
import InputColor from "../../helpers/InputColor";



function ScheduleNew(props)
{


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzien:  "",
        dzien_valid:  false,
        godzina: "",    
        godzina_valid: false,    
        godzina_koniec: "",    
        godzina_koniec_valid: false,    
        archwalny: '0',
        hex:'',
        fraza: '',
        px_group_id: '',
            
    });





    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const empSelected = (id) => {

 

        setRow( {...row, ['px_group_id']:id  } );
    }



    const saveData = (e) => {


       

        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

    

        if(row.px_group_id == undefined || row.px_group_id =='' || row.px_group_id < 1)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Nie wybrano pracownika" ,  "ok"  ,null); 
            return; 
        }

        if(row.dzien == undefined || row.dzien == null || row.dzien.length < 3 )
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Podaj dzień" ,  "ok"  ,null); 
                return; 
            }


        if(row.godzina == undefined || row.godzina == null || row.godzina.length < 3 )
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Podaj godzinę" ,  "ok"  ,null); 
                return; 
            }            
        
        if(row.godzina_koniec == undefined || row.godzina_koniec == null || row.godzina_koniec.length < 3 )
           {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Podaj godzinę" ,  "ok"  ,null); 
                return; 
            }    
         

 
        e.currentTarget.innerHTML = "Czekaj...";        
    

        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1_emps,schedule_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Dane zostały zapisane" , "ok" , null);    
                       props.onSuccess();                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {

    setRow({
        dzien:  "",
        godzina: "",    
        godzina_koniec: "",    
        fraza: '',
        px_group_id: '',
        hex:'',
    });
        
        if(view == 'btn') {setView("dlg"); }  else setView('btn');
    }     

 

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setView('btn');
        }


    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Godziny pracy
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                        

                                        <div className="form_control">
                                            <div className="fieldName">Pracownik</div>
                                            <InputSearchEmp  mainView={props.mainView} userData={props.userData}   err={errTab} empSelected={empSelected} valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Pracownik: "} className=' w250 ' req='1' firstUp="1" />
                                        </div>

                            

                                        <div className="form_control">
                                            <div className="fieldName">Dni</div>
                                            <InputDateMulti   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>

                                        
                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">Od godziny</div>
                                            <InputTime   userData={props.userData} value={row.godzina} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina" placeholder={"Od: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>
                                        
                                        <div className="form_control">
                                            <div className="fieldName">Do godziny</div>
                                            <InputTime   userData={props.userData} value={row.godzina_koniec} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_koniec" placeholder={"Do: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">Oznacz kolorem</div>
                                            <InputColor   userData={props.userData} value={row.hex} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="hex" placeholder={"Do: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>
 

                                        <div className="form_split"></div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;


    return  <div className="inline_block">
                <div className="btn"    onClick={changeView} >zaplanuj godziny pracy </div> 
                {dlg_view} 
           </div>
}


export default ScheduleNew;